/**
 * SectionHeader — a consistent subtitle/label divider used between page sections.
 *
 *   <SectionHeader label="Analytics" />
 *   <SectionHeader label="Items" trailing={<button …>Add Item</button>} />
 *
 * Visual-only. No logic.
 */
export default function SectionHeader({ label, description, trailing, testid }) {
  return (
    <div
      data-testid={testid || `section-header-${(label || "").toLowerCase().replace(/\s+/g, "-")}`}
      className="flex items-end justify-between gap-3 mb-4"
    >
      <div className="min-w-0">
        <div className="vp-label">{label}</div>
        {description && <p className="text-xs vp-muted mt-1">{description}</p>}
      </div>
      {trailing}
    </div>
  );
}
